export default __webpack_public_path__ + "static/media/020-sauce.91fc9283.svg";